<template lang="html">
    <div class="d-flex flex-column h-100 position-relative">
        <div class="navigator">
            <h2 class="mr-auto">Promocodes</h2>
        </div>

        <div class="d-flex flex-column overflow-auto">
            <div class="d-flex justify-content-end pt-4 pr-3">
                <span class="mr-3 color-6 pointer" @click="deleteBtn">Delete</span>
                <button class="btn blue wide mr-3" @click="cancelBtn">Cancel</button>
                <button class="btn secondary wide mr-3" @click="pauseBtn" :class="{'disabled': isPromocodeInvalid || !isValidWeekDays}">Pause</button>
                <button class="btn wide mr-3" @click="saveBtn" :class="{'disabled': isPromocodeInvalid || !isValidWeekDays}">Save</button>
                <button class="btn wide mr-3" @click="publishBtn" :class="{'disabled': isPromocodeInvalid || !isValidWeekDays}">Publish</button>
                <button class="btn wide blue" @click="pressSeeAffectedEvents">Preview list of events</button>
            </div>

            <div class="px-3 py-4 d-flex flexGrow1">
                <div class="col-sm-12">
                    <promocode-form v-if="promocode && promocode.id" :promocode="promocode" @change="promocodeChanged" @hasWeekDays="weekDaysValidation($event)"></promocode-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'

    import PromocodeForm from './components/promocodeForm'

    export default {
        data() {
            return {
                promocode: null,
                isPromocodeInvalid: false,
                promocodeValidation: null,
                isValidWeekDays: false,
            }
        },
        created() {
            // Prevents access to url directly without a selected promocode
            if (!this.getSelectedPromocode || !this.getSelectedPromocode.id) {
                this.$router.push({name:'promocodes'});
            } else {
                this.promocode = this.getSelectedPromocode;
            }
        },
        computed: {
            ...mapGetters([
                'getSelectedPromocode',
            ]),
        },
        methods: {
            ...mapActions([
                'updatePromocode',
                'updatePromocodeActive',
                'updatePromocodePause',
                'deletePromocode',
                'openModal',
            ]),
            weekDaysValidation(isValid) {
                this.isValidWeekDays = isValid;
            },
            deleteBtn() {
                this.deletePromocode(this.promocode).then(response => {
                    this.$router.push({name:'promocodes'});
                });
            },
            cancelBtn() {
                this.$router.push({name:'promocodes'});
            },
            pauseBtn() {
                if (!this.isPromocodeInvalid && this.isValidWeekDays) {
                    this.updatePromocodePause(this.promocode).then(response => {
                        this.$router.push({name:'promocodes'});
                    });
                } else {
                    this.promocodeValidation.promocode.$touch();
                }
            },
            saveBtn() {
                if (!this.isPromocodeInvalid && this.isValidWeekDays) {
                    this.updatePromocode(this.promocode).then(response => {
                        this.$router.push({name:'promocodes'});
                    });
                } else {
                    this.promocodeValidation.promocode.$touch();
                }
            },
            publishBtn() {
                if (!this.isPromocodeInvalid && this.isValidWeekDays) {
                    this.updatePromocodeActive(this.promocode).then(response => {
                        this.$router.push({name:'promocodes'});
                    });
                } else {
                    this.promocodeValidation.promocode.$touch();
                }
            },
            promocodeChanged(e) {
                this.isPromocodeInvalid = e.v.promocode.$invalid;
                this.promocodeValidation = e.v;
            },
            pressSeeAffectedEvents() {
                this.openModal('PromocodeAffectedEvents');
            }
        },
        components: {
            PromocodeForm
        },
    }
</script>



// WEBPACK FOOTER //
// promocodeEdit.vue?3899230c